import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/shared/folder/$folderId/')({
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
});
